
import LandingHeader from '../LandingHeader';
import { CricketBowlingBase } from './Cricket-Bowling-Base';

export const CricketBowlingHome = () => {
    const sportKey = "cricket";

    return (<CricketBowlingBase 
                banner={<LandingHeader sportKey={sportKey} headline="Improve your action" subHeading="Real-time analysis, slow-motion replays, auto-pause, casting, and more..." images={[
                                    {src: "./assets/img/cricket/hero_analyse.png", caption: "Real-time analysis", captionTop: '59%'},
                                    {src: "./assets/img/cricket/hero_replay.png", caption: "Slow motion instant replays", captionTop: '55%'},
                                    {src: "./assets/img/cricket/hero_auto_pause.png", caption: "Auto pause and save", captionTop: '55%'},
                                    {src: "./assets/img/cricket/hero_cast.png", caption: "Cast to tablet or laptop", captionTop: '55%'},
                                ]} />} />
    
    );
}

export default CricketBowlingHome;